module.exports = __webpack_public_path__ + "3b220235.jpg";